/**
 * The User type Codes Enum as defined in the backend api.
 *
 * @see https://mathletics.atlassian.net/wiki/spaces/GAM/pages/577437701/Sign+In+Page
 * @see https://bitbucket.org/mathletics/3p-portal/src/cb2b7c4a900da9ee5ca0ef946956c6e99c8cbfef/common/user-service/userTypes.js#userTypes.js-4
 */
export enum UserTypes {
    authenticatedUsers = 0,
    schoolStudents = 1,
    teachers = 2,
    schoolAdmins = 3,
    parents = 4,
    homeStudents = 5,
    districtAdmins = 6,
    internalUsers = 7,
    applicationUsers = 8,
    anonymousUsers = 9
}
